var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-comments-overview-wrapper",
    },
    [
      _vm.showBlocks ? _c("courseware-block-comments-overview") : _vm._e(),
      _vm._v(" "),
      _vm.showElements
        ? _c("courseware-structural-element-comments-overview")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#courseware-comments-overview-widget-filter-type",
            name: "sidebar-views",
          },
        },
        [_c("courseware-comments-overview-widget-filter-type")],
        1
      ),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#courseware-comments-overview-widget-filter-created",
            name: "sidebar-views",
          },
        },
        [_c("courseware-comments-overview-widget-filter-created")],
        1
      ),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#courseware-comments-overview-widget-filter-unit",
            name: "sidebar-views",
          },
        },
        [_c("courseware-comments-overview-widget-filter-unit")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }